<template>
    <v-autocomplete
        ref="r_province"
        v-model="reqProvince"
        :disabled="!req.filter.hosp"
        :clearable="req.filter.hosp"
        color="teal"
        label="Province"
        :items="provinceItems"
        item-text="city_province"
        item-value="uid"
        return-object
        auto-select-first
        autocomplete="nope"
        :loading="loading.req.province"
        @change="handleChangeReqProvince($event)"
    >
        <template #item="{ item }">
            <v-list-item-content>
                <v-list-item-title>{{ item.city_province }}</v-list-item-title>
                <v-list-item-subtitle>{{ item.city_region }}</v-list-item-subtitle>
            </v-list-item-content>
        </template>
    </v-autocomplete>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    props: ['req', 'member_model', 'loading'],
    data: () => ({
        reqProvince: null
    }),
    computed: {
        ...mapGetters(['getReqProvinces']),
        provinceItems() {
            return (this.getReqProvinces || []).map(item => ({
                ...item,
                uid: `${item.city_region}${item.city_province}`
            }))
        }
    },
    watch: {
        getReqProvinces() {
            this.loading.req.province = false
        },
        'req.province'(newVal) {
            if (!newVal) {
                this.reqProvince = null
                return
            }
            this.reqProvince = this.provinceItems.find(i => i.city_province === newVal) || null
        }
    },
    methods: {
        ...mapActions(['reqCities', 'reqHospClin']),
        handleChangeReqProvince(item) {
            if (!item) {
                this.req.province = null
                this.req.city = ''
                this.req.facility = ''
                this.req.filter.doc = false
                this.req.specField = { sp_name: 'ALL', sp_desc: '' }
                this.req.hospClinDoctor = ''
                this.req.hospClinType = 'H'
                this.req.decking = ''

                this.loading.req.city = true
                this.reqCities({ REGION: this.req.region ? this.req.region : '', PROVINCE: '' })

                this.loading.req.hospital = true
                this.reqHospClin({
                    REGION: this.req.region ? this.req.region : '',
                    PROVINCE: '',
                    CITY: '',
                    TYPE: '',
                    MEMBN: this.member_model.MEMB_N
                })
                return
            }

            this.req.province = item.city_province
            this.req.region = item.city_region
            this.req.city = ''
            this.req.facility = ''
            this.req.filter.doc = false
            this.req.specField = { sp_name: 'ALL', sp_desc: '' }
            this.req.hospClinDoctor = ''
            this.req.hospClinType = 'H'
            this.req.decking = ''

            this.loading.req.city = true
            this.reqCities({ REGION: item.city_region, PROVINCE: item.city_province })

            this.loading.req.hospital = true
            this.reqHospClin({
                REGION: item.city_region,
                PROVINCE: item.city_province,
                CITY: '',
                TYPE: '',
                MEMBN: this.member_model.MEMB_N
            })
        }
    }
}
</script>
